<template>
  <section-page
    title="Appointments"
    description="Here are all your upcoming appointments."
    full-height
  >
    <template v-slot:right>
      <up-next-appointment-filter></up-next-appointment-filter>
    </template>

    <app-loading-section
      :loading="isLoading"
      :count="appointments.length"
      heading="There are no upcoming appointments at the moment"
    >
      <template v-if="appointments.length">
        <up-next-appointment-item
          v-for="appointment in appointments"
          :key="appointment.id"
          :appointment="appointment"
        ></up-next-appointment-item>
      </template>
    </app-loading-section>
  </section-page>
</template>

<script>
import UpNextAppointmentItem from './components/UpNextAppointmentItem';
import UpNextAppointmentFilter from "./components/UpNextAppointmentFilter";
export default {
  name: "UpNextAppointmentsTab",
  components: {UpNextAppointmentFilter, UpNextAppointmentItem },
  data() {
    return {
      isLoading: true,
      showMoreIsLoading: false,
      nextPageUrl: null,
    }
  },
  created() {
    this.get();
  },
  computed: {
    appointments() {
      return this.$store.getters["upNext/pendingAppointments"];
    }
  },
  methods: {
    get() {
      this.$api.clientStore.getAppointments(this.$store.getters.account.id).then(res => {
        this.$store.commit('setRoot', { store: 'upNext', prop: 'pendingAppointments', data: res.data.data });
        this.isLoading = false;
      });
    }
  }
}
</script>
